import React from "react";
import "./index.css";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// Create a root.
const container = document.getElementById("root");
const root = createRoot(container);

// Initial render
root.render(
  <BrowserRouter basename="/poslovni-softver">
    <App />
  </BrowserRouter>
);
